import { Outlet } from "react-router-dom";
import { MarketingHeader } from "@/components/marketing/MarketingHeader";
import { MarketingFooter } from "@/components/marketing/MarketingFooter";

export default function MarketingLayout() {
  return (
    <>
      <MarketingHeader />
      <main className="min-h-screen bg-[#0C1222]">
        <Outlet />
      </main>
      <MarketingFooter />
    </>
  );
}
